import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { privateRequest } from "../commonApi/CommonApi";
import Swal from "sweetalert2";
function Signin() {
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("token");
    // Only navigate if token exists and is not empty
    if (token && token.trim() !== "") {
      navigate("/dashboard");
    } else {
      // Clear any invalid tokens
      localStorage.clear();
      sessionStorage.clear();
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await privateRequest.post(`accountAdmin/login`, {
        mobile: mobile,
        password: password,
      });
      if (response.data.success) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("AdminName", response?.data?.user?.name);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Logged in successfully!",
        });
        navigate("/dashboard");
      } else {
        if (!response.data.mobile && !response.data.password) {
          Swal.fire({
            icon: "error",
            title: "Login Failed!",
            text: "Mobile number and password are incorrect!",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Login Failed!",
            text:
              response.data.message || "Mobile number or password incorrect!",
          });
        }
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  return (
    <div>
      <main
        className="auth"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <form className="auth-form" style={{ borderRadius: "40px" }}>
          <div className="form-group">
            <div className="form-label-group">
              <input
                type="text"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                id="inputUser"
                className="form-control"
                placeholder="Mobile No"
                autoFocus=""
              />{" "}
              <label htmlFor="inputUser">Mobile No</label>
            </div>
          </div>

          <div className="form-group">
            <div className="form-label-group">
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                id="inputPassword"
                className="form-control"
                placeholder="Password"
              />{" "}
              <label htmlFor="inputPassword">Password</label>
            </div>
          </div>

          <div className="form-group">
            {/* <Link  className="btn btn-lg btn-primary btn-block">
            Sign In
          </Link> */}

            <button
              onClick={handleSubmit}
              className="btn btn-lg btn-primary btn-block"
            >
              {" "}
              Sign In
            </button>
          </div>
        </form>
      </main>
    </div>
  );
}

export default Signin;
